/**
 * İstatistik ekranı için sayı / tarih biçimlendiricileri.
 * Binlik ayırıcı ".", ondalık ",".
 */

const LOCALE = "tr-TR";

const MILLION = 1000000;

/** 4286 → "4.286" */
export function FormatNumber(value, fractionDigits = 0) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";

  return Number(value).toLocaleString(LOCALE, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

/** 23800000 → "₺23,8" + birim "mn"; küçük tutarlar tam yazılır. */
export function FormatCompactCurrency(value) {
  const amount = Number(value) || 0;

  if (Math.abs(amount) >= MILLION) {
    return { value: `₺${FormatNumber(amount / MILLION, 1)}`, unit: "mn" };
  }

  return { value: `₺${FormatNumber(amount, 0)}`, unit: "" };
}

/** 9420000 → "9,42" + "mn lt" */
export function FormatCompactLitre(value) {
  const amount = Number(value) || 0;

  if (Math.abs(amount) >= MILLION) {
    return { value: FormatNumber(amount / MILLION, 2), unit: "mn lt" };
  }

  return { value: FormatNumber(amount, 0), unit: "lt" };
}

/** 23800000 → "₺23.800.000,00" */
export function FormatCurrency(value, fractionDigits = 2) {
  const amount = Number(value) || 0;
  return `₺${FormatNumber(amount, fractionDigits)}`;
}

/** -1.8 → "−1,8%" (işaretli, tipografik eksi) */
export function FormatSignedPercent(value) {
  const rate = Number(value) || 0;
  const sign = rate > 0 ? "+" : rate < 0 ? "−" : "";
  return `${sign}${FormatNumber(Math.abs(rate), 1)}%`;
}

/** 91.3 → "%91,3" */
export function FormatPercent(value) {
  return `%${FormatNumber(Number(value) || 0, 1)}`;
}

/** "HASAN ACIR" → "HA" */
export function Initials(fullName) {
  if (!fullName) return "?";

  return fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join("")
    .toLocaleUpperCase(LOCALE);
}

/** Bugünse saat, değilse gün.ay — son işlemler listesi için */
export function FormatActivityTime(value) {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const now = new Date();
  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  return sameDay
    ? date.toLocaleTimeString(LOCALE, { hour: "2-digit", minute: "2-digit" })
    : date.toLocaleDateString(LOCALE, { day: "2-digit", month: "2-digit" });
}
